module.exports = __webpack_public_path__ + "img/userLogo1.373f8113.jpg";